class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
  function responsiveMenu(){
    if(jQuery(window).width() < 768) {
      $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
    }
    else { 
      $('.product-filter-column').prependTo('.product-list-row');
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    }
  }
  jQuery(document).ready(function() {
    responsiveMenu();
    countDownIni('.flip-countdown,.js-flip-countdown'); 
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view ");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-price-wrapper').insertBefore(prod_form);  

        var prod_pri = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-variation-wrapper').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        
          var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_label);
        
        var prod_btn2 = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.time-counter').insertAfter(prod_btn2); 

         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
         var timer_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').prependTo(timer_btn);

         var timer_btn = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('p').insertAfter(timer_btn);

        var prod_title = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_title);

        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-price-wrapper').appendTo(prod_rew);

        var prod_rew = jQuery(this).find('.product-price-wrapper');
        jQuery(this).find('.product-form').appendTo(prod_rew);

        var prod_btn = jQuery(this).find('.product-price-wrapper');
        jQuery(this).find('.product-variation-wrapper').insertBefore(prod_btn);  
        
      });
    });
    
  // load-more button scroll
if ($('.load-more_wrap').hasClass('load-more-btn')){
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val());
  var data_winurl = window.location.href.split('/collections');
  var final_data_url = data_winurl[1];
  var finalURL = "/collections" + final_data_url;
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      if (finalURL.includes('filter.')) {
        $('[data-next-link]').val(finalURL + "&page=" + next_coll);
       }else{
         $('[data-next-link]').val(finalURL + "?page=" + next_coll);
       }
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-grid-view, .product-list-view').append($(responseHTML).find('.product-grid-view, .product-list-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

        jQuery('.product-list-view > .grid__item').each(function() {
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-price-wrapper').insertBefore(prod_form);  

        var prod_pri = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-variation-wrapper').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
      
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    

  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-grid-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
}
// load-more button scroll end

    
  });
  jQuery(window).resize(function() {
    responsiveMenu();
  });
    $(document).ready(function() {
         countDownIni('.flip-countdown,.js-flip-countdown'); 
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no_scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    });
    });
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function countDownIni(countdown) {
 $(countdown).each(function () {
   var countdown = $(this);
   var promoperiod;
   if (countdown.attr('data-promoperiod')) {
     promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
   } else if (countdown.attr('data-countdown')) {
     promoperiod = countdown.attr('data-countdown');
   }
   if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
     $(this).addClass('countdown-block');
     countdown.countdown(promoperiod, function (event) {
       // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
       countdown.html(event.strftime("<div class='counter'><span class='count count-days'>%D</span></div>" + "<div class='counter'><span class='count count-hours'>%H</span></div>" + "<div class='counter'><span class='count count-minites'>%M</span></div>" + "<div class='counter'><span class='count count-seconds'>%S</span></div>"));
     });
   }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
 });
}
